import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ViewController } from 'ionic-angular';
import { ErrorType, ValidationResult } from '../../../models/projects/validation.models';
import { ErrorsComponent } from '../../shared/components/errors/errors.component';
import { SetupService } from '../../../services/setup/setup.service';
import { SetupChangeDeleteValidationResult } from '../../../models/setup/setup.models';
import { AppConfig } from '../../../app/app.config';
import { CycleChangeDeleteValidation } from '../../../models/cycles/cycle.models';
import { CyclesService } from '../../../services/cycles/cycles.service';
import { DateService } from '../../../services/date/date.service';

@Component({
  selector: 'app-choice',
  styles: ['signature-date-modal.component.scss'],
  templateUrl: './confirmation-modal.component.html',
})

export class ConfirmationModalComponent implements OnInit {
  config = AppConfig.settings;

  title: string;
  item: string;
  message: string;
  optionalMessage: string;
  idleTimer: number;
  idleTimerShow: string;
  validation: ValidationResult;
  trueText: string = 'Yes';
  falseText: string = 'No';
  showButtons: boolean = false;
  showKeepCommentsCheckbox: boolean = false;
  confirmationOnly: boolean = false;
  keepComments: boolean = false;
  typeId: number;
  itemId: number;
  setupChangeValidation: SetupChangeDeleteValidationResult;
  cycleChangeDeleteValidation: CycleChangeDeleteValidation;

  errors: string[] = [];
  warnings: string[] = [];
  loading: boolean;

  constructor(
    params: NavParams,
    public viewController: ViewController,
    public modalController: ModalController,
    private setupService: SetupService,
    private cyclesService: CyclesService,
    private dateService: DateService,
  ) {
    this.title = params.get('title');
    this.message = params.get('message');
    this.item = params.get('comment');
    this.optionalMessage = params.get('optionalMessage');
    this.validation = params.get('validation');
    const trueText = params.get('trueText');
    this.typeId = params.get('typeId');
    this.itemId = params.get('itemId');
    this.showButtons = params.get('showButtons');
    this.showKeepCommentsCheckbox = params.get('showKeepCommentsCheckbox');
    this.confirmationOnly = params.get('confirmationOnly');
    this.idleTimer = params.get('idleTimer');

    if (!!trueText) {
      this.trueText = trueText;
    }

    if (this.idleTimer) {
      this.idleTimerShow = new Date(this.idleTimer * 1000).toISOString().substr(14, 5);
      // uses web worker, because a normal set interval doesn't work when the page is minimized because javascript is single threaded
      // web worker runs on a separate thread though so the set interval still works there
      const worker = new Worker("../../../assets/timer-worker.js");

      worker.onmessage = () => {
        if (this.idleTimer !== 0) {
          this.idleTimer--;
          this.idleTimerShow = new Date(this.idleTimer * 1000).toISOString().substr(14, 5);
        }
      };
    }

    const falseText = params.get('falseText');

    if (!!falseText) {
      this.falseText = falseText;
    }

    if (!!this.validation) {
      this.errors = this.validation.errors
        .filter(p => p.type === ErrorType.Error || ErrorType.Default)
        .map(p => p.message);

      this.warnings = this.validation.errors
        .filter(p => p.type === ErrorType.Warning)
        .map(p => p.message);
    }
  }

  async ngOnInit() {
    this.loading = true;

    switch (this.typeId) {
      case 4: // location change
      case 5: // stage change
      case 6: // phase change
      case 7: // project change
      case 9: // vessel master change
      case 18: // time zone change
        this.setupService.canDeleteSetupChange(this.itemId)
          .subscribe(result => {
            this.setupChangeValidation = result;
            if (this.setupChangeValidation.errors.length > 0 || this.setupChangeValidation.warnings.length > 0) {
              this.title = 'Warning';

              if (this.setupChangeValidation.errors.length > 0) {
                this.message = 'The Setup Change cannot be deleted due to the following reasons:';
                this.optionalMessage = '';
              }

              const modal = document.getElementsByClassName('modal-wrapper');
              for (let i = 0; i < modal.length; i++) {
                modal[i].setAttribute('style', 'height: 500px; margin-top: -250px; opacity: 1');
              }
            }

            this.loading = false;
          });
        break;
      case 20: // cycle change
        this.cycleChangeDeleteValidation = await this.cyclesService.getDeleteChangeValidation(this.itemId);
        if (!this.cycleChangeDeleteValidation.canDelete) {
          this.title = 'Cycle Cannot Be Deleted';
          const blockingCycle = this.cycleChangeDeleteValidation.blockingCycle;
          this.message = blockingCycle
            ? `Cycle ${this.cycleChangeDeleteValidation.cycleOrdinal} cannot be deleted as ` +
              `Cycle ${blockingCycle.ordinal} still exists starting at ${this.dateService.setFullTimeString(blockingCycle.startDateUtc)}.`
            : this.cycleChangeDeleteValidation.message;
          this.optionalMessage = '';
          this.falseText = 'Close';
        }
        this.loading = false;
        break;
      default:
        this.loading = false;
        break;
    }
  }

  get cycleDeletionBlocked(): boolean {
    return !!this.cycleChangeDeleteValidation && !this.cycleChangeDeleteValidation.canDelete;
  }

  closeModal(choice: boolean) {
    this.viewController.dismiss({choice: choice, keepComments: this.keepComments});
  }

  openErrorModal() {
    const errorModal = this.modalController.create(ErrorsComponent, {validationResult: this.validation});
    errorModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/confirmation-modal/confirmation-modal.component.ts